export default __webpack_public_path__ + "71d8cd580b3142bdbf8c006aed94f10a.png";